import VueRouter from 'vue-router';

import Index from '../Index'
import Login from '../Login'

const routes = [
  { path: '/', name: 'login', component: Login },
  { path: '/index', name: 'index', component: Index }
];

export default new VueRouter({
  mode: 'history',
  routes,
})



// WEBPACK FOOTER //
// ./src/components/router/index.js